import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SidebarAdmin from '../../composant/SidebarAdmin';
import Sidebar from './../../composant/Sidebar/Sidebar';

export default function PainelHeroAdmin() {
  const [form, setForm] = useState({
    titulo: '',
    botao_texto: '',
    botao_link: '',
    imagem: null
  });
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    axios.get('https://congolinaria.com.br/api/home_hero.php')
      .then(res => {
        if (res.data) {
          setForm({
            titulo: res.data.titulo || '',
            botao_texto: res.data.botao_texto || '',
            botao_link: res.data.botao_link || '',
            imagem: null
          });
          if (res.data.imagem) setPreview(`https://congolinaria.com.br/${res.data.imagem}`);
        }
      })
      .catch(err => console.error('Erro ao carregar dados do Hero:', err));
  }, []);

  const handleChange = e => {
    const { name, value, files } = e.target;
    if (name === 'imagem') {
      setForm(prev => ({ ...prev, imagem: files[0] }));
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('titulo', form.titulo);
    formData.append('botao_texto', form.botao_texto);
    formData.append('botao_link', form.botao_link);
    if (form.imagem) formData.append('imagem', form.imagem);

    try {
      const res = await axios.post('https://congolinaria.com.br/api/home_hero.php', formData, {
        withCredentials: true
      });
      alert(res.data?.mensagem || 'Atualizado com sucesso.');
    } catch (error) {
      console.error('Erro ao salvar:', error);
      alert('Erro ao salvar.');
    }
  };

  return (
    <div className="flex">
        <Sidebar />
      <div className="flex-1 p-6 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4">Editar Banner da Home (Hero)</h2>
        <form onSubmit={handleSubmit} className="space-y-4" encType="multipart/form-data">
          <input
            type="text"
            name="titulo"
            value={form.titulo}
            onChange={handleChange}
            placeholder="Título do Hero"
            className="w-full border p-2 rounded"
            required
          />
          <input
            type="text"
            name="botao_texto"
            value={form.botao_texto}
            onChange={handleChange}
            placeholder="Texto do Botão"
            className="w-full border p-2 rounded"
            required
          />
          <input
            type="text"
            name="botao_link"
            value={form.botao_link}
            onChange={handleChange}
            placeholder="Link do Botão"
            className="w-full border p-2 rounded"
            required
          />
          <input
            type="file"
            name="imagem"
            onChange={handleChange}
            accept="image/*"
            className="w-full border p-2 rounded"
          />
          {preview && <img src={preview} alt="Preview" className="mt-2 w-full max-h-64 object-contain" />}
          <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600">
            Salvar Alterações
          </button>
        </form>
      </div>
    </div>
  );
}
